module.exports = __webpack_public_path__ + "media/src/application/media/rooms/Media3-74c3759a2e6700f93c602b93112135a5.png";